import { FileInfoDto, IPagedCollection } from '@sr/dto';
import { FILES_BASE_URL } from 'shared/api/api';
import { CollectionParams } from 'shared/api/rtk-query';
import { pagingDataToParams } from 'utils/remote-paged-collection.hook';
import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQuery } from 'shared/api/rtk-query';

export const filesApi = createApi({
  reducerPath: FILES_BASE_URL,
  baseQuery: createBaseQuery(),
  endpoints: () => ({}),
});

const injectedApi = filesApi.injectEndpoints({
  endpoints: (builder) => ({
    getFilesList: builder.query<IPagedCollection<FileInfoDto>, CollectionParams>({
      query: ({ paging, filter }: CollectionParams) => ({
        url: `${FILES_BASE_URL}/all?${filter}`,
        params: paging && pagingDataToParams(paging),
        method: 'GET'
      })
    }),
  }),
  overrideExisting: true
});

export const fileListApi = injectedApi.enhanceEndpoints({
  addTagTypes: ['FILES_LIST'],
  endpoints: {
    getFilesList: {
      providesTags: ['FILES_LIST']
    }
  }
});